/* eslint-disable max-len */

import { useTeamMemberContext } from 'Screens/Dashboard/Team/Components/TeamCellHandler/TeamInteractions/Interactions/Details/TeamMemberDetailsContext';
import EmailInput from 'Components/Common/EmailInput/EmailInput';

const TeamMemberEmailInput = () => {
    const { values } = useTeamMemberContext();
    const { email: currentEmail } = values;

    return (
        <EmailInput
            email={currentEmail}
            disabled
        />
    );
};

export default TeamMemberEmailInput;
